<p-card class="p-card container">
  <h3 i18n>Informations du client</h3>

  <form [formGroup]="form">
    <div class="layout__inner-card margin--bottom-medium">
      <div class="layout--gap margin--bottom-medium">
        <div class="layout--full-width">
          <label class="label-top" for="firstName" i18n>Prénom</label>
          <input
            i18n-placeholder
            placeholder="Prénom"
            [formControl]="form.controls.firstName"
            id="firstName"
            type="text"
            [maxLength]="25"
            pInputText />
        </div>

        <div class="layout--full-width">
          <label class="label-top" for="language" i18n>Langue</label>
          <p-dropdown
            [options]="languageOptions | emTranslate"
            i18n-placeholder
            placeholder="Choisir"
            [formControl]="form.controls.language"
            id="language"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>
      </div>
    </div>
  </form>
</p-card>
